module.exports = __webpack_public_path__ + "img/so.84655542.png";